import React, { useEffect } from 'react';
import _ from 'lodash';
import  {Header } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { connectDynamic } from 'framework/hocs';
import { FemaGoTable } from 'app-ui-componentlibrary';
import { Alert } from 'app-ui-componentlibrary/dist/componentLibrary/layout';
import {
    safeAdd,
    convertValueToDollar,
  } from 'common/utils';

export const DonatedResourcesSummaryTable = (props) => {
    const {
        header,
        totalCostsPath,
        appSharePath,
        fedSharePath,
        otherSubGrantTotalPath,
    } = props;
    
    const totalCosts = _.get(props, totalCostsPath, 0);
    const appShare = _.reduce(_.get(props, appSharePath, []), (total, share) => safeAdd(total, share), 0);
    const fedShare = _.reduce(_.get(props, fedSharePath, []), (total, share) => safeAdd(total, share), 0);

    const otherSubGrantTotal = _.get(props, otherSubGrantTotalPath, {});
    const otherSubGrantsAppShareTotal = _.get(otherSubGrantTotal, 'appShare');
    return (
        <React.Fragment>
            <Alert 
                type="warning"
                header="Donated resources federal share calculation"
                content="The federal share of donated resources cannot exceed the total out of pocket costs for all awarded Category B and H work and is capped at the total non-federal cost share of these subapplications. FEMA does not obligate the donated resource subapplication until after it obligates all Category B and H subapplications. The cap will adjust as subapplications are awarded."
            />
            <Header as="h4" id={props.id}>
              {header ? header : 'Donated resources summary'}
            </Header>
            <FemaGoTable summary="Donated resources summary table">
                <FemaGoTable.Body>
                    <FemaGoTable.Row>
                        <FemaGoTable.TextCell>
                            Total non-federal resources for all awarded Category B and Category H subapplications
                        </FemaGoTable.TextCell>
                        <FemaGoTable.NumberCell>
                            {convertValueToDollar(otherSubGrantsAppShareTotal)}
                        </FemaGoTable.NumberCell>
                    </FemaGoTable.Row>
                    <FemaGoTable.Row>
                        <FemaGoTable.TextCell>
                            Total donated resources costs
                        </FemaGoTable.TextCell>
                        <FemaGoTable.NumberCell>
                            {convertValueToDollar(totalCosts)}
                        </FemaGoTable.NumberCell>
                    </FemaGoTable.Row>
                    <FemaGoTable.Row>
                        <FemaGoTable.TextCell>
                            Federal resources of donated resources costs
                        </FemaGoTable.TextCell>
                        <FemaGoTable.NumberCell>
                            {convertValueToDollar(fedShare)}
                        </FemaGoTable.NumberCell>
                    </FemaGoTable.Row>
                    <FemaGoTable.Row>
                        <FemaGoTable.TextCell>
                            Non-federal resources of donated resources costs
                        </FemaGoTable.TextCell>
                        <FemaGoTable.NumberCell>
                            {convertValueToDollar(appShare)}
                        </FemaGoTable.NumberCell>
                    </FemaGoTable.Row>
                </FemaGoTable.Body>
            </FemaGoTable>
        </React.Fragment>
    )
};

export const mapStateToProps = (state) => {
    return {
        data: state.dynamicComponent.data
    }
}

export default connect(mapStateToProps)(connectDynamic(DonatedResourcesSummaryTable));